export interface Category {
  name: string;
  url: string;
  icon: string;
  imageSeq: string;
  description: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    imageSeq: 'cat-shoes-01',
    description: 'Top sneakers and footwear from verified ACBuy spreadsheet listings',
  },
  {
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    icon: 'ri-t-shirt-line',
    imageSeq: 'cat-hoodies-02',
    description: 'Premium hoodies and sweaters with best price ratings',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    icon: 'ri-shirt-line',
    imageSeq: 'cat-tshirts-03',
    description: 'Trending t-shirts curated from the spreadsheet database',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    icon: 'ri-vip-crown-line',
    imageSeq: 'cat-jackets-04',
    description: 'High-quality jackets at unbeatable spreadsheet prices',
  },
  {
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    icon: 'ri-pantone-line',
    imageSeq: 'cat-pants-05',
    description: 'Stylish pants and shorts handpicked from top-rated sellers',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    icon: 'ri-user-smile-line',
    imageSeq: 'cat-headwear-06',
    description: 'Caps, beanies and more from the ACBuy item list',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    icon: 'ri-stack-line',
    imageSeq: 'cat-sets-07',
    description: 'Complete outfit sets with verified spreadsheet ratings',
  },
  {
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    icon: 'ri-checkbox-blank-line',
    imageSeq: 'cat-underwear-08',
    description: 'Comfortable essentials from trusted ACBuy spreadsheet vendors',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    icon: 'ri-medal-line',
    imageSeq: 'cat-jersey-09',
    description: 'Sports jerseys and athletic wear at competitive prices',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    icon: 'ri-glasses-line',
    imageSeq: 'cat-accessories-10',
    description: 'Watches, jewelry and accessories from the ACBuy database',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    icon: 'ri-briefcase-line',
    imageSeq: 'cat-bags-11',
    description: 'Backpacks, handbags and luggage with best value ratings',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    icon: 'ri-loop-left-line',
    imageSeq: 'cat-belts-12',
    description: 'Designer-style belts sourced from top ACBuy spreadsheet picks',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    icon: 'ri-drop-line',
    imageSeq: 'cat-perfumes-13',
    description: 'Fragrances and perfumes from the shopping spreadsheet comparison',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    icon: 'ri-more-line',
    imageSeq: 'cat-other-14',
    description: 'More hidden gems from the ACBuy spreadsheet 2026 collection',
  },
];